import { SavedCartPosition } from "./savedCartPosition";

export class SavedCartDto {
	public id: number = 0;
	public name: string = "";
	public positions: SavedCartPosition[] = new Array<SavedCartPosition>();
}
